<template>
  <div v-if="loading" class="flex h-full justify-center items-center">
    <loading-spinner diameter="64px" />
  </div>

  <alert-badge
    v-else-if="error.title"
    isDanger
    :title="error.title"
    :body="error.body"
    @dismissed="
      () => {
        error.title = ''
        error.body = ''
      }
    "
  />

  <Insurance-form
    v-else
    :initInsurance="initInsurance"
    :successMsg="$t('actions.saveChangesSuccess')"
    :submitAction="update"
  />
</template>

<script lang="ts">
import { defineComponent, onBeforeMount, ref } from 'vue'

import { useHTTP } from '@/plugins/http'

import Insurance from '@/models/insurance/Insurance'

// components
import LoadingSpinner from '@/components/LoadingSpinner.vue'
import InsuranceForm from '@/views/companies/insurances/InsuranceForm.vue'
import AlertBadge from '@/components/AlertBadge.vue'
import { useRoute, useRouter } from 'vue-router'

export default defineComponent({
  name: 'Insurance',
  components: {
    LoadingSpinner,
    InsuranceForm,
    AlertBadge
  },
  setup() {
    const initInsurance = ref(new Insurance())
    const error = ref({ title: '', body: '' })
    const http = useHTTP()
    const loading = ref(true)
    const route = useRoute()
    const router = useRouter()


    onBeforeMount(async () => {
      const url = `${Insurance.ENDPOINT}/${route.params.id}`

      try {
        const resp = await http.get<Insurance>(url)
        initInsurance.value = Insurance.from(resp)
      } catch (errorResp) {
        error.value.title = errorResp.title
        error.value.body = errorResp.body
      }

      loading.value = false
    })

    const update = async (insurance: Insurance) => {
      try {
        const url = `${Insurance.ENDPOINT}/${insurance.id}`
        const resp = await http.put<Insurance>(url, insurance)
        initInsurance.value = Insurance.from(resp)
        router.back();
      } catch (error) {
        return error
      }
    }

    return {
      initInsurance,
      error,
      loading,
      update
    }
  }
})
</script>
